import { Button, Grid, Box, IconButton, Stack, Typography, TextField as MuiTextField } from '@mui/material';
import { useForm } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { getMonthYear } from '../../../../../utils';

const TABLE_HEADER = [
  {
    header: 'Batch No.',
    accessor: 'batch_no'
  },
  {
    header: 'Exp Date',
    accessor: (row) => getMonthYear(row?.exp_date)
  },
  {
    header: 'Available Stock',
    accessor: (row)=> row?.productDetails?.totalQuantity
  }
];

export const EditConsignmentDetailsForm = ({
  onClose,
  onAdd,
  editData,
  isEditMode,
  stock,
  setAddDetailsDialogOpen,
  stockProductDetails
}) => {
  const [input, setInput] = useState('');
  console.log(editData,"EDIT DATA IS HERE !!")
  const methods = useForm({
    resolver: yupResolver(Yup.object().shape({})),
    defaultValues: {},
    mode: 'all'
  });
  const { reset } = methods;

  const { handleSubmit, setValue, watch } = methods;



  useEffect(() => {
    if (isEditMode && editData) {
      const formattedExpDate = editData.exp_date
        ? new Date(editData.exp_date).toISOString().slice(0, 7)
        : '';
  
      const rate = parseFloat(editData.rate);
      const billQty = parseFloat(editData.bill_qty);
      const calculatedAmount = rate * billQty;
      const gst = parseFloat(editData.gst);
      const gstAmt = (calculatedAmount * gst) / 100;
      const discAmt = parseFloat(editData.dis_amt);
      const discountAmount = (discAmt);
      const taxable =(calculatedAmount - discountAmount)
      const netAmount = (gstAmt + taxable);
  
      reset({
        product_name:
          editData.product?.main?.name ||
          editData?.productDetails?.productInfo?.main?.name ||
          '',
        rate: rate,
        mrp: editData.mrp,
        bill_qty: billQty,
        amount: calculatedAmount ,
        batch_no: editData.batch_no,
        exp_date: formattedExpDate,
        gst: gst,
        gst_amt: gstAmt,
        cgst: gstAmt / 2 ,
        sgst: gstAmt / 2,
        taxable: taxable,
        net_amt: netAmount,
        hsn_code: editData.hsn_code,
        free_qty : editData.free_qty,
        product:
          editData?.productDetails?.productInfo?._id ||
          editData.product?._id ||
          '',
        _id: editData._id,
      });
    } else {
      reset();
    }
  }, [isEditMode, editData, reset]);
  

  const formSubmitHandler = (formValues) => {
    const transformedValues = {
      ...formValues
    };
    onAdd(transformedValues);
    setAddDetailsDialogOpen(false);
  };

  const rateWatch = watch('rate');
  const billQty = watch('bill_qty');
 const gst = watch('gst')
 const discAmt = watch('dis_amt');
 const freeQty = watch('free_qty');

  useEffect(() => {
    setValue('amount', rateWatch * billQty);
    setValue('gst_amt', rateWatch * billQty*gst/100)
    setValue('cgst', (rateWatch * billQty*gst/100)/2)
    setValue('sgst', (rateWatch * billQty*gst/100)/2)
    setValue('taxable',((rateWatch * billQty) - discAmt) || 0)
    setValue('net_amt',(((rateWatch * billQty) + (rateWatch*billQty)*gst/100) - discAmt) || 0)
    setValue('rec_qty', Number(billQty)+ Number(freeQty));
  });

  

  return (
    <Stack spacing={1} sx={{ height: '100%' }}>
      <Stack
        padding={1.5}
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
        borderBottom="1px solid"
        borderColor="grey.300"
      >
        <Typography variant="h4" fontWeight="bold">
          Edit Bill Quantity
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon color="error" fontSize="large" />
        </IconButton>
      </Stack>
      <FormProvider
        sx={{ height: '100%', overflow: 'auto' }}
        methods={methods}
        onSubmit={handleSubmit(formSubmitHandler)}
      >
        <Grid container spacing={1} sx={{ flex: 1, height: '100%', overflow: 'auto' }}>
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.2, px: 2 }}>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Product Name</Typography>
                <TextField sx={{ flex: 0.8 }} name="product_name" placeholder="Product Name" disabled/>
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Rate</Typography>
                <TextField sx={{ flex: 0.8 }} name="rate" placeholder="Bill Qty" disabled />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Bill Qty</Typography>
                <TextField sx={{ flex: 0.8 }} name="bill_qty" placeholder="Bill Qty" type="number"/>
              </Stack>
                   <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Free Qty</Typography>
                <TextField sx={{ flex: 0.8 }} name="free_qty" placeholder="Free Qty" type="number" disabled/>
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.35, fontWeight: 700, fontSize: '1.4rem' }}>Exp Date/HSN Code</Typography>
                  <TextField sx={{ flex: 0.3 }} name="batch_no" placeholder="Batch No"  disabled/>
                <TextField sx={{ flex: 0.3 }} name="exp_date" type="month" disabled/>
                <TextField sx={{ flex: 0.3 }} name="hsn_code" disabled/>
              </Stack>

              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>GST%</Typography>
                <TextField sx={{ flex: 0.8 }} name="gst" placeholder="GST %" disabled/>
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.35, fontWeight: 700, fontSize: '1.4rem' }}>GST/CGST/SGST Amt</Typography>
                   <TextField sx={{ flex: 0.3 }} name="gst_amt" placeholder="GST Amt" disabled/>
                <TextField sx={{ flex: 0.3 }} name="cgst" placeholder="GST %" disabled/>
                <TextField sx={{ flex: 0.3}} name="sgst" placeholder="GST %" disabled/>
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Amount/Disc Amt</Typography>
                <TextField sx={{ flex: 0.4 }} name="amount" placeholder="GST %" disabled />
                <TextField sx={{ flex: 0.4 }} name="dis_amt" placeholder="Disc Amt" disabled />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Taxable</Typography>
                <TextField sx={{ flex: 0.8 }} name="taxable" placeholder="Taxable" disabled />
              </Stack>

              <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end" sx={{marginTop:"1%"}}>
                <Button variant="contained" type="submit">
                  Add
                </Button>
                <Button variant="outlined" onClick={onClose} color="error">
                  Close
                </Button>
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </FormProvider>
    </Stack>
  );
};
